import { Operation } from './operation';
import { User } from './user';
import { ProjectColumnAccessModel } from './project-column-access-model';
import { Resource } from './resource';
import { Role } from './role';
import { IRosterProject } from './roster/roster-project';

export class UserContext
{
  zoesenUser: User;
  userOperations: Operation[];
  externalLinks: Resource[];
  roles: Role[];
  isAdmin: boolean;
  isSysAdmin: boolean;
  projectColumnAccessSettings: {
    [para: string]: ProjectColumnAccessModel
  };
  rosterProjects: IRosterProject[]
}
